import { useEffect } from 'react'
import useAuth from '../../../context/auth.context.jsx';
import { useNavigate } from 'react-router';

export default function Logout() {
    const { logOut } = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        logOut();
        navigate('/login');
    }, []);
    return null;
}